import { apiRequest } from './apiClient.js'
import { parseContract } from '../contracts/generated/contracts.js'
import { readLogResponse, saveLogResponse, clearLogResponse } from './responseRevalidation.js'

export function mergeLogUpdate(previous, update, limit) {
  const append = update.mode === 'append' && previous
  const combined = `${append ? previous.logs : ''}${update.logs}`
  let lines = combined.split('\n').filter(Boolean)
  const maxLines = Math.max(1, Math.min(Number(limit) || 500, update.window.maxLines))
  const dropped = lines.length > maxLines
  lines = lines.slice(-maxLines)
  let bytes = new TextEncoder().encode(lines.join('\n')).length
  let truncated = false
  while (lines.length && bytes + 1 > update.window.maxBytes) {
    bytes -= new TextEncoder().encode(lines.shift()).length + 1
    truncated = true
  }
  return { ...update, logs: lines.length ? `${lines.join('\n')}\n` : '', window: {
    ...update.window,
    oldestAvailableAt: (append ? previous.window.oldestAvailableAt || update.window.oldestAvailableAt : update.window.oldestAvailableAt) || null,
    newestAvailableAt: update.window.newestAvailableAt || (append && previous.window.newestAvailableAt) || null,
    truncated: truncated || update.window.truncated || Boolean(append && previous.window.truncated),
    lineLimitReached: dropped || update.window.lineLimitReached || Boolean(append && previous.window.lineLimitReached),
  } }
}

export async function loadBackendUpdates(query, options = {}) {
  const path = `/api/logs/backend?${query.toString()}&incremental=1`
  let saved = readLogResponse(path)
  try {
    if (saved) {
      parseContract('log_window_response', saved.data)
      if (!saved.data.cursor || saved.data.cursor !== saved.etag) saved = null
    }
  } catch { saved = null; clearLogResponse() }
  try {
    const update = await apiRequest(`${path}${saved ? `&cursor=${encodeURIComponent(saved.data.cursor)}` : ''}`, {
      ...options, cache: 'no-store', responseContract: 'log_window_response',
    })
    if (!['reset', 'append'].includes(update.mode) || !update.cursor || (update.mode === 'append' && !saved)) {
      throw new Error('Invalid log update response')
    }
    // A cursor is accepted only after server authorization for this owner and query.
    const result = mergeLogUpdate(saved?.data, update, query.get('limit'))
    saveLogResponse(path, update.cursor, result)
    return result
  } catch (error) {
    if (error.status === 401 || error.status === 403) clearLogResponse()
    throw error
  }
}
